"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M4.92 5.757A1 1 0 0 1 5.89 5h12.22a1 1 0 0 1 .97.757l.892 3.568a1 1 0 0 1 .028.23 3.2 3.2 0 0 1-1.425 2.662l-.075.05V19a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-6.666A2.69 2.69 0 0 1 4 9.919V9.53q0-.093.022-.182zM6.5 12.5V19h2v-3a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5v3h2v-6.5h-.04a3.5 3.5 0 0 1-2.886-1.519 2.94 2.94 0 0 1-5.148 0A3.5 3.5 0 0 1 6.541 12.5zm3.506-3.018.092.459a1.94 1.94 0 0 0 3.804 0l.092-.46L13.559 6H10.44zM9.434 6H5.89L5 9.562v.357c0 .703.434 1.33 1.087 1.581h.454a2.5 2.5 0 0 0 2.451-2.01l.014-.07zm5.132 0 .428 3.42.014.07a2.5 2.5 0 0 0 2.451 2.01h.39l.172-.115A2.2 2.2 0 0 0 19 9.562L18.11 6zM14.5 19v-3a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v3z"
}), 'Pickup');
